module.exports = __webpack_public_path__ + "static/media/taggis_laptop.90e04db9.jpg";